import { createStore, Middleware, Reducer, Store, StoreEnhancer } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import invariant from 'redux-immutable-state-invariant';
// import { Effect } from 'redux-saga';
import { Effect } from 'redux-saga/effects';
import { applyMiddleware } from 'redux-subspace';
import createSagaMiddleware from 'redux-subspace-saga';

function buildStore<T>(rootReducer: Reducer<T>, sagas: Array<() => Iterator<Effect>> = []): Store<T> {
    const sagaMiddleware = createSagaMiddleware();

    const middleware: Middleware[] = [sagaMiddleware];

    if (process.env.NODE_ENV !== 'production') {
        middleware.unshift(invariant());
    }

    const enhancer: StoreEnhancer<T> = composeWithDevTools(
        applyMiddleware(...middleware),
    );

    const store = createStore(rootReducer, enhancer);

    sagas.map((saga) => (sagaMiddleware.run(saga)));

    return store;
}

export default buildStore;
